module.exports = " <div :id=crop_id class=\"cropbox-image empty\"> <div :style=styleObject> <img :src=src /> </div> <icon class=picture-icon name=picture-o> </icon></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Cropbox.vue
// module id = 326
// module chunks = 2